const HINT = {
  PASSWORD_PATTERN: 'Password must be at least 8 characters long and have at least one uppercase letter and one number.',
};

export default HINT;
